import { useRouter } from 'next/navigation';
import qs from 'qs';

import { snackbar } from '@flipster/react/design-system/snackbar';

import { emailSchema } from '@web/utils/session-validator';

function useClickSignUp() {
  const router = useRouter();

  return ({ email }: { email: string }) => {
    try {
      emailSchema.validateSync(email);

      const queryString = qs.stringify({ email });
      router.push(`/email-signup?${queryString}`);
    } catch {
      const message = !email ? 'Please enter your e-mail.' : 'Invalid e-mail address.';
      snackbar.error({ message });
    }
  };
}

export default useClickSignUp;
